import { useCallback } from 'react';
/**
 * Take a function and wrap it in a standard user input event function
 *
 * For reducing boilerplate when we just want an event's .target.value
 */ export function useEventValueCallback(func, extraDependencies = []) {
    return useCallback((e)=>{
        func(e.target.value);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        func,
        ...extraDependencies
    ]);
}
